document.addEventListener('DOMContentLoaded', () => {

  const selectors = [
    '.category-card',
    '.collection-list__item',
    '.collection-card',
    '.card-wrapper',
    '.product-card',
    'product-card',
    '.grid__item',
    '.multicolumn-card'
  ];

  let observer = null;


  /**
   * 创建 IntersectionObserver
   */
  function createObserver() {

    if (observer) {
      observer.disconnect();
    }

    observer = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {

        if (!entry.isIntersecting) return;

        const item = entry.target;

        /*
         * 根据当前元素在同一批元素中的位置
         * 设置轻微的逐个延迟
         */
        const allItems = document.querySelectorAll(
          selectors.join(',')
        );

        const index = Array.from(allItems).indexOf(item);

        const delay = (index % 5) * 100;

        setTimeout(() => {

          item.classList.add('show');

        }, delay);


        observer.unobserve(item);

      });

    }, {
      threshold: 0.15
    });

  }


  /**
   * 初始化当前页面中的动画元素
   */
  function initScrollAnimation() {

    if (!observer) {
      createObserver();
    }

    const items = document.querySelectorAll(
      selectors.join(',')
    );

    items.forEach((item) => {

      /*
       * 已经处理过的元素不重复处理
       */
      if (item.dataset.scrollAnimationInitialized === 'true') {
        return;
      }

      item.dataset.scrollAnimationInitialized = 'true';

      item.classList.add('scroll-item');

      /*
       * 如果元素已经在视口里面，
       * 直接显示，避免 Shopify 筛选后商品消失
       */
      const rect = item.getBoundingClientRect();

      const isVisible =
        rect.top < window.innerHeight &&
        rect.bottom > 0;

      if (isVisible) {

        item.classList.add('show');

      } else {

        observer.observe(item);

      }

    });

  }


  /*
   * 第一次加载
   */
  initScrollAnimation();


  /*
   * Shopify Section 动态加载
   */
  document.addEventListener(
    'shopify:section:load',
    () => {

      setTimeout(() => {
        initScrollAnimation();
      }, 100);

    }
  );


  /*
   * Shopify Section 重新渲染
   */
  document.addEventListener(
    'shopify:section:reorder',
    () => {

      setTimeout(() => {
        initScrollAnimation();
      }, 100);

    }
  );


  /*
   * 监听 DOM 变化
   *
   * Shopify 筛选通常通过 AJAX 替换商品列表，
   * MutationObserver 可以捕获这些新生成的 product-card。
   */
  const mutationObserver = new MutationObserver((mutations) => {

    let shouldUpdate = false;

    mutations.forEach((mutation) => {

      if (mutation.addedNodes.length > 0) {
        shouldUpdate = true;
      }

    });

    if (shouldUpdate) {

      setTimeout(() => {
        initScrollAnimation();
      }, 150);

    }

  });


  mutationObserver.observe(document.body, {

    childList: true,
    subtree: true

  });

});